import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {serialize} from "../../../helpers/utils/Utils";

export const highRiskAccountVerifiedApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchHighRiskAccountsVerified: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/high-risk-account-verified/search?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['highRiskAccountVerified'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        deleteHighRiskAccountVerifiedById: build.mutation({
            query: (highRiskAccountVerifiedId) => {
                return {
                    url: `/ajax/high-risk-account-verified/delete/${highRiskAccountVerifiedId}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['highRiskAccountVerified'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "High Risk Account Verified");
            },
        }),

    }),
});


export const {
    useSearchHighRiskAccountsVerifiedQuery,
    useDeleteHighRiskAccountVerifiedByIdMutation
} = highRiskAccountVerifiedApi;